import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const InputPhone = phoneDecorator(InputSimple);
const InputName = nameDecorator(InputSimple);

const InputSettings = css`
    display: block;
    width: 100%;
    margin: 0;
`;

export const Wrapper = styled(DefaultPopup)<{ isShowMobilePlank: boolean }>`
    max-width: 596px !important;
    width: 100% !important;
    border-radius: 24px !important;
    padding: 59px;

    @media (max-width: ${wideBreakpoints.mobile}) {    
        padding: 24px;
        margin-top: ${({ isShowMobilePlank }) => isShowMobilePlank ? 230 : 147}px !important;
        min-height: fit-content !important;
    }
`;

export const Title = styled.div`
    ${FONTS.H2}
    margin-bottom: 16px;
`;

export const Subtitle = styled.div`
    ${FONTS.M}
    margin-bottom: 41px;
`;

export const Name = styled(InputName)`
    ${InputSettings}
`;

export const Phone = styled(InputPhone)`
    ${InputSettings}
`;

export const InputBlock = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    gap: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;

export const Button = styled(BaseButton)`
    ${FONTS.S}
    width: 100%;
    margin: 16px 0 8px;
`;

export const InfoText = styled.div`
    margin-top: 12px;
    ${FONTS.XXS}
    display: inline-block;
`;

export const AgreeLink = styled.a.attrs({
    href: 'https://dom.ru/policy.pdf?_ga=2.194887981.1682807258.1580735380-296976907.1577435201',
    target: '_blank',
})`
    ${FONTS.XS}
`;
